import {Component, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, identifier, ReportModel} from "@fedeltapointofsale/data-client";
import {InventorySearchPageComponent} from "../inventory-search-page/inventory-search-page.component";

export class InventoryReportSelectionData extends EntityData<InventoryReportSelectionData> {
    @identifier inventoryId: number;
    @field name: string;
    @field inventorygroup: string;
}

@Component({
    selector: "wbo-inventory-report-selection",
    templateUrl: "./inventory-report-selection-control.component.html"
})
export class InventoryReportSelectionControlComponent {

    InventorySearchPageComponent = InventorySearchPageComponent;

    fieldName: string = "inventories";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromInventory(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((inventory: any) => inventory.inventoryId === item.inventoryId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
